<h1 mat-dialog-title id="propagate-question-title">Update school lists</h1>
<mat-dialog-content>
  <p class="propagate-question-dialog__lead">{{ data.questionLabel }}</p>
  <p class="propagate-question-dialog__id">ID: {{ data.questionId }} · Aid year {{ data.aidYear }}</p>

  @if (phase === 'confirm') {
    <p>
      This replaces the question on every school list for this aid year that already includes it.
      Schools whose published aid year matches get the change on the live calculator.
      Schools that do not already include this question are left alone.
    </p>
  }

  @if (phase === 'working') {
    <p role="status" aria-live="polite">Updating school lists…</p>
  }

  @if (phase === 'result' && result) {
    <p role="status" aria-live="polite">
      Scanned {{ result.schoolsScanned }} schools and updated {{ result.documentsUpdated }} lists.
      Replaced the question {{ result.questionsReplaced }} times.
    </p>
  }

  @if (phase === 'error') {
    <p role="alert">{{ errorMessage }}</p>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (phase === 'confirm') {
    <button type="button" mat-button mat-dialog-close>Cancel</button>
    <button type="button" mat-raised-button color="primary" (click)="updateLists()">Update school lists</button>
  } @else if (phase === 'working') {
    <button type="button" mat-button disabled>Updating…</button>
  } @else {
    <button type="button" mat-raised-button color="primary" mat-dialog-close>Close</button>
  }
</mat-dialog-actions>
